/* Forzono — "atelier journey": pinned scroll scenes, opening sequence and follower cursor. No dependencies. */
(function () {
  'use strict';
  var root = document.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var ease = function (t) { return 1 - Math.pow(1 - t, 3); };
  var isSmall = function () { return window.innerWidth < 750; };
  var pad = function (n) { return String(n).padStart(2, '0'); };

  /* ---------- Opening sequence ---------- */
  function intro() {
    var el = document.getElementById('Intro');
    if (!el || !root.classList.contains('intro-on')) { if (el) el.remove(); return; }
    var count = el.querySelector('[data-intro-count]');
    var bar = el.querySelector('[data-intro-bar]');
    var t0 = performance.now(), dur = 1900, done = false;
    function finish() {
      if (done) return; done = true;
      el.classList.add('is-done');
      try { sessionStorage.setItem('fz-intro', '1'); } catch (e) {}
      setTimeout(function () { root.classList.remove('intro-on'); el.remove(); }, 1100);
    }
    function tick(now) {
      var t = clamp((now - t0) / dur, 0, 1), v = ease(t);
      count.textContent = String(Math.round(v * 100)).padStart(3, '0');
      bar.style.transform = 'scaleX(' + v.toFixed(3) + ')';
      if (t < 1) requestAnimationFrame(tick); else setTimeout(finish, 250);
    }
    requestAnimationFrame(tick);
    el.addEventListener('click', finish); // skippable
    window.addEventListener('keydown', finish, { once: true });
  }

  /* ---------- Pinned scenes ---------- */
  var pins = [], visible = new Set(), raf = 0, io;

  function Pin(el) {
    this.el = el; this.type = el.dataset.pin; this.cur = 0; this.seeded = false;
    this.counter = el.querySelector('[data-pin-counter]');
    this.bar = el.querySelector('[data-pin-bar]');
    if (this.type === 'craft') {
      this.n = parseInt(el.dataset.steps, 10) || 1;
      this.draws = [].slice.call(el.querySelectorAll('[data-draw]'));
      this.fades = [].slice.call(el.querySelectorAll('[data-fade]'));
      this.fills = [].slice.call(el.querySelectorAll('[data-fill]'));
      this.dots = [].slice.call(el.querySelectorAll('[data-step-dot]'));
      this.bodies = [].slice.call(el.querySelectorAll('[data-step]'));
      this.draws.forEach(function (d) { d.style.strokeDasharray = '1'; d.style.strokeDashoffset = '1'; });
    }
    if (this.type === 'film') {
      this.frame = el.querySelector('[data-film-frame]');
      this.media = el.querySelector('.jr-film__media');
      this.caption = el.querySelector('.jr-film__caption');
      this.hud = el.querySelector('.jr-film__hud');
    }
    if (this.type === 'hero') {
      this.frame = el.querySelector('[data-hf-frame]');
      this.media = el.querySelector('.hero-film__media');
      this.content = el.querySelector('[data-hf-content]');
      this.hud = el.querySelector('[data-hf-hud]');
      this.cue = el.querySelector('[data-hf-scroll]');
    }
    if (this.type === 'track') {
      this.track = el.querySelector('[data-track]');
      this.cards = [].slice.call(el.querySelectorAll('.jr-card'));
      this.n = this.cards.length - 1;
    }
    this.layout();
  }
  Pin.prototype.isStatic = function () { return reduced || (this.type === 'track' && isSmall()); };
  Pin.prototype.layout = function () {
    var el = this.el;
    el.classList.toggle('is-static', this.isStatic());
    if (this.isStatic()) { el.style.height = ''; this.apply(1, true); return; }
    if (this.type === 'track') {
      var vw = window.innerWidth, vh = window.innerHeight;
      var last = this.cards[this.cards.length - 1];
      // offsetLeft already includes the left padding; add the same gutter once on the right
      var padL = parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
      this.max = last ? Math.max(0, last.offsetLeft + last.offsetWidth + padL - vw) : 0;
      // card geometry measured once per layout; scrolling only does arithmetic
      this.vw = vw;
      this.geo = this.cards.map(function (c) { return { img: c.querySelector('.jr-card__img'), x: c.offsetLeft, w: c.offsetWidth }; });
      el.style.height = (this.max + vh * 1.1) + 'px';
    }
    if (this.type === 'craft') el.style.height = (this.n * 100 + 60) + 'vh';
    if (this.type === 'film') el.style.height = '260vh';
    if (this.type === 'hero') el.style.height = ({ short: 170, medium: 220, long: 280 }[el.dataset.length] || 220) + 'vh';
  };
  Pin.prototype.raw = function () {
    var r = this.el.getBoundingClientRect(), total = this.el.offsetHeight - window.innerHeight;
    return total > 0 ? clamp(-r.top / total, 0, 1) : 0;
  };
  // write a style only when its value changes (saves style recalcs and repaints while scrolling)
  function set(node, prop, val) {
    var c = node.__fxc || (node.__fxc = {});
    if (c[prop] === val) return;
    c[prop] = val; node.style[prop] = val;
  }
  var _hh = 0;
  function headerH() {
    if (!_hh) _hh = parseFloat(getComputedStyle(root).getPropertyValue('--header-h')) || 84;
    return _hh;
  }
  window.addEventListener('resize', function () { _hh = 0; });
  document.addEventListener('fz:header-h', function () { _hh = 0; });
  Pin.prototype.apply = function (p, staticMode) {
    var el = this.el;
    if (this.type === 'craft') {
      var i;
      for (i = 0; i < this.draws.length; i++) {
        var d = this.draws[i], s = +d.dataset.s, du = +d.dataset.d;
        d.style.strokeDashoffset = (1 - clamp((p - s) / du, 0, 1)).toFixed(4);
      }
      for (i = 0; i < this.fades.length; i++) {
        var f = this.fades[i];
        f.style.opacity = clamp((p - +f.dataset.s) / +f.dataset.d, 0, 1).toFixed(3);
      }
      for (i = 0; i < this.fills.length; i++) {
        var fl = this.fills[i], o = clamp((p - +fl.dataset.s) / +fl.dataset.d, 0, 1);
        fl.style.opacity = o.toFixed(3);
        if (fl.classList.contains('bp-stonefill')) fl.style.opacity = (o * 0.22).toFixed(3);
      }
      var fs = p * (this.n - 1 + 0.0001), idx = Math.round(clamp(fs, 0, this.n - 1));
      this.bodies.forEach(function (b, k) {
        var dd = fs - k, op = staticMode ? 1 : clamp(1 - Math.max(0, Math.abs(dd) - 0.22) * 3.2, 0, 1);
        var bl = (staticMode || op > 0.97 || op < 0.03) ? 0 : Math.round((1 - op) * 6 * 2) / 2;   // half-px steps, max 6px
        set(b, 'opacity', op.toFixed(2));
        set(b, 'filter', bl ? 'blur(' + bl + 'px)' : 'none');
        set(b, 'transform', staticMode ? 'none' : 'translate3d(0,' + (-dd * 36).toFixed(1) + 'px,0)');
        set(b, 'visibility', op < 0.01 ? 'hidden' : 'visible');
        b.classList.toggle('is-active', k === idx);
      });
      this.dots.forEach(function (dot, k) { dot.classList.toggle('is-active', k === idx); dot.classList.toggle('is-past', k < idx); });
      if (this.counter) this.counter.textContent = pad(idx + 1) + ' / ' + pad(this.n);
      if (this.bar) this.bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
    }
    if (this.type === 'film') {
      var e = staticMode ? 1 : ease(clamp(p / 0.55, 0, 1));
      var x = ((1 - e) * 27).toFixed(2), y = ((1 - e) * 24).toFixed(2), r = ((1 - e) * 30).toFixed(1);
      this.frame.style.clipPath = 'inset(' + y + '% ' + x + '% ' + y + '% ' + x + '% round ' + r + 'px)';
      if (this.media) this.media.style.transform = 'scale(' + (1.22 - 0.22 * e).toFixed(4) + ')';
      var co = staticMode ? 1 : clamp((p - 0.5) / 0.18, 0, 1);
      this.caption.style.opacity = co.toFixed(3);
      this.caption.style.transform = 'translate3d(0,' + ((1 - co) * 30).toFixed(1) + 'px,0)';
      this.caption.style.filter = 'blur(' + ((1 - co) * 8).toFixed(1) + 'px)';
      this.hud.style.opacity = (staticMode ? 1 : clamp((p - 0.3) / 0.2, 0, 1)).toFixed(3);
    }
    if (this.type === 'hero') {
      if (staticMode) p = 0; // static: the full-screen opening frame with everything visible
      var vh = window.innerHeight, small = isSmall();
      // 1 · headline lifts away with a soft blur
      var tOut = ease(clamp(p / 0.36, 0, 1));
      if (this.content) {
        this.content.style.opacity = (1 - tOut).toFixed(3);
        this.content.style.transform = 'translate3d(0,' + (-tOut * vh * 0.12).toFixed(1) + 'px,0)';
        var hb = tOut > 0.02 && tOut < 0.98 ? Math.round(tOut * 8 * 2) / 2 : 0;
        set(this.content, 'filter', hb ? 'blur(' + hb + 'px)' : 'none');
        this.content.style.visibility = tOut > 0.995 ? 'hidden' : 'visible';
      }
      if (this.cue) this.cue.style.opacity = (1 - clamp(p / 0.08, 0, 1)).toFixed(3);
      // 2 · the film draws back into a framed window on the warm dark ground
      var f = ease(clamp((p - 0.16) / 0.64, 0, 1));
      // top clears the sticky header; bottom leaves room for the caption line
      var hh = headerH();
      var top = (f * (hh + vh * 0.035)).toFixed(1), bot = (f * vh * (small ? 0.12 : 0.09)).toFixed(1);
      var ix = (f * (small ? 5 : 7)).toFixed(2), rr = (f * (small ? 18 : 28)).toFixed(1);
      if (this.frame) this.frame.style.clipPath = 'inset(' + top + 'px ' + ix + '% ' + bot + 'px ' + ix + '% round ' + rr + 'px)';
      // 3 · slow push-in that settles as it frames
      if (this.media) set(this.media, 'transform', 'scale(' + (1.05 - 0.05 * ease(clamp(p / 0.85, 0, 1))).toFixed(4) + ')');
      if (this.hud) this.hud.style.opacity = clamp((p - 0.55) / 0.2, 0, 1).toFixed(3);
    }
    if (this.type === 'track' && !staticMode) {
      this.track.style.transform = 'translate3d(' + (-p * this.max).toFixed(1) + 'px,0,0)';
      var vw = this.vw || window.innerWidth, off = -p * this.max;
      (this.geo || []).forEach(function (g) {
        if (!g.img) return;
        // scale(1.18) leaves 9% of the card width spare on each side: never shift past it (no edge gaps)
        var lim = g.w * 0.085;
        var shift = clamp(((g.x + off + g.w / 2) - vw / 2) * -0.1, -lim, lim);
        set(g.img, 'transform', 'translate3d(' + shift.toFixed(1) + 'px,0,0) scale(1.18)');
      });
      var idx2 = clamp(Math.round(p * (this.n - 1)), 0, this.n - 1);
      if (this.counter) this.counter.textContent = this.n > 0 ? pad(idx2 + 1) + ' / ' + pad(this.n) : '';
      if (this.bar) this.bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
    }
  };

  function frame() {
    raf = 0;
    var moving = false;
    var list = [];
    visible.forEach(function (pin) { if (!pin.isStatic()) list.push([pin, pin.raw()]); });   // all reads first
    list.forEach(function (e) {                                                               // then all writes
      var pin = e[0], target = e[1];
      if (!pin.seeded) { pin.cur = target; pin.seeded = true; }
      pin.cur += (target - pin.cur) * 0.12;
      if (Math.abs(target - pin.cur) > 0.0004) moving = true; else pin.cur = target;
      pin.apply(pin.cur);
    });
    if (moving) raf = requestAnimationFrame(frame);
  }
  function kick() { if (!raf) raf = requestAnimationFrame(frame); }

  function toggleMedia(pin, on) {
    var v = pin.el.querySelector('video');
    if (!v) return;
    if (on) { var pr = v.play && v.play(); if (pr && pr.catch) pr.catch(function () {}); } else v.pause();
  }

  function setup(scope) {
    [].forEach.call((scope || document).querySelectorAll('[data-pin]'), function (el) {
      if (el.__pin) return;
      var pin = el.__pin = new Pin(el);
      pins.push(pin);
      io.observe(el);
    });
    kick();
  }

  /* ---------- Follower cursor ---------- */
  function cursor() {
    if (!root.hasAttribute('data-cursor-on')) return;
    if (reduced || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var c = document.createElement('div');
    c.className = 'jr-cursor'; c.innerHTML = '<span class="jr-cursor__label"></span>';
    document.body.appendChild(c);
    var label = c.firstChild, x = -100, y = -100, cx = x, cy = y, shown = false;
    document.addEventListener('mousemove', function (e) {
      x = e.clientX; y = e.clientY;
      if (!shown) { shown = true; cx = x; cy = y; c.classList.add('is-on'); }
      var t = e.target.closest ? e.target.closest('a, button, [data-cursor], summary, input, select, textarea') : null;
      c.classList.toggle('is-hover', !!t);
      var lab = t && t.getAttribute('data-cursor-label');
      label.textContent = lab || '';
      c.classList.toggle('has-label', !!lab);
    }, { passive: true });
    document.addEventListener('mouseleave', function () { c.classList.remove('is-on'); shown = false; });
    // content moves under a still pointer: re-check what it is over, at most ~8× a second
    var hitTimer = 0;
    window.addEventListener('scroll', function () {
      if (!shown || hitTimer) return;
      hitTimer = setTimeout(function () {
        hitTimer = 0;
        var el = document.elementFromPoint(x, y);
        var t = el && el.closest ? el.closest('a, button, [data-cursor], summary, input, select, textarea') : null;
        var lab = t && t.getAttribute('data-cursor-label');
        c.classList.toggle('is-hover', !!t); c.classList.toggle('has-label', !!lab);
        if (label.textContent !== (lab || '')) label.textContent = lab || '';
      }, 120);
    }, { passive: true });
    // follow loop only runs while the ring is catching up with the pointer
    var looping = false;
    function loop() {
      cx += (x - cx) * 0.2; cy += (y - cy) * 0.2;
      if (Math.abs(x - cx) < 0.1 && Math.abs(y - cy) < 0.1) { cx = x; cy = y; looping = false; }
      c.style.transform = 'translate3d(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px,0)';
      if (looping) requestAnimationFrame(loop);
    }
    document.addEventListener('mousemove', function () { if (!looping) { looping = true; requestAnimationFrame(loop); } }, { passive: true });
  }

  function init() {
    intro();
    if (!document.querySelector('.jr-craft')) {
      [].forEach.call(document.querySelectorAll('a[href="#journey-craft"]'), function (a) { a.hidden = true; });
    }
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var pin = en.target.__pin; if (!pin) return;
          if (en.isIntersecting) { visible.add(pin); toggleMedia(pin, true); } else { visible.delete(pin); toggleMedia(pin, false); }
        });
        kick();
      }, { rootMargin: '50% 0px' });
      setup(document);
    }
    window.addEventListener('scroll', kick, { passive: true });
    window.addEventListener('resize', function () { pins.forEach(function (p) { p.layout(); }); kick(); });
    window.addEventListener('load', function () { pins.forEach(function (p) { p.layout(); }); kick(); });
    cursor();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  /* ---------- Theme editor ---------- */
  function relayout() { pins.forEach(function (p) { p.layout(); }); kick(); }
  document.addEventListener('shopify:section:load', function (e) { if (io) { setup(e.target); relayout(); } });
  document.addEventListener('shopify:section:unload', function (e) {
    pins = pins.filter(function (p) {
      if (!e.target.contains(p.el)) return true;
      if (io) io.unobserve(p.el); visible.delete(p); return false;
    });
  });
  document.addEventListener('shopify:section:reorder', function () { setTimeout(relayout, 50); });
  // Selecting a step / card in the editor scrolls the pinned scene to it
  document.addEventListener('shopify:block:select', function (e) {
    var sec = e.target.closest('[data-pin]');
    if (!sec || !sec.__pin || sec.__pin.isStatic()) return;
    var pin = sec.__pin, idx = -1, n = 1;
    if (pin.type === 'craft') { idx = +(e.target.getAttribute('data-step') || -1); n = pin.n; }
    if (pin.type === 'track') { idx = pin.cards.indexOf(e.target.closest('.jr-card')); n = pin.n; }
    if (idx < 0) return;
    var top = sec.getBoundingClientRect().top + window.scrollY;
    var p = n > 1 ? idx / (n - 1) : 0;
    window.scrollTo({ top: top + p * (sec.offsetHeight - window.innerHeight) + 2, behavior: 'smooth' });
  });

  // "See how it's made" style links point at the first craft scene, wherever it is (or hide if it was removed)
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#journey-craft"]');
    if (!a) return;
    var target = document.querySelector('.jr-craft');
    if (!target) return;
    e.preventDefault();
    var y = target.getBoundingClientRect().top + window.scrollY;
    if (window.__lenis) window.__lenis.scrollTo(y); else window.scrollTo({ top: y, behavior: reduced ? 'auto' : 'smooth' });
  });
})();
